const commonErrMsg = "系统繁忙，请稍后再试"
/**
 * 用来规范cgi报错时的报错提示（单行提示）
 * @param {Object} res cgi返回的结果
 * @return {String} 用于alert给用户的报错提示信息
 */
export function parse(res) {
  res = res || {}
  if (res.err_code) {
    return commonErrMsg + "（" + res.err_code + "）"
  }

  if (!res.msg) {
    return commonErrMsg + (res.ret ? "（" + res.ret + "）" : "")
  }

  return res.msg
}
